import {formatAmountOverPeriod, formatAmountWithCurrency} from "../../util/formatter.ts";
import OrderAddressSearchComponent from "../order/OrderAddressSearchComponent.tsx";
import {DispatchHighLightAddressSearchEvent} from "../../util/events.ts";
import PhoneNumberSpanComponent from "../callMe/PhoneNumberSpanComponent.tsx";
import Icon from "../selfcare/Icon.tsx";
import IconArrow from "../icons/IconArrow.tsx";

const oprettelse = 398;
const tilslutning = 699;
const _default = 299;

const kampagne = 99;
const tid = 6;
const rabat = tid * (_default - kampagne);
const total = oprettelse + tilslutning + rabat;

const min_6 = (6 * kampagne);
const network = 'Fibia';
const end = '30.06.25';

const phone = '70603073';

export default function FibiaHeroComponent() {
    return (
        <>

            <div id="hero-container" className="hero-container hero-container--tilbud-simple-1">
                <div className="hero-background-wrapper">
                    <div className="hero-background"></div>
                </div>
                <div className="hero-content">
                    <h1>
                        Få <strong>1000 Mbit</strong> fibernet<br/>
                        fra <span className="nowrap"><strong><span className="hiper-text-stroke">{kampagne}</span>,-</strong>/md.</span> i <strong>{tid}</strong>&nbsp;mdr.<br/>
                        <span className="price-after">Herefter {formatAmountOverPeriod(_default)}</span>
                    </h1>
                </div>
                <div className="address-wrap">
                    <h2>
                        Bestil her<div className="scroll-down-arrow"></div>
                    </h2>
                    <OrderAddressSearchComponent/>
                </div>
            </div>

            <div className="hero-container hero-container--tilbud-simple-2">
                <div className="total-discount-container">
                    <div className="total-discount">
                        <h3 className="heading heading--small heading--left">
                            <span className="hide-on-small-devices">Så meget sparer du</span>
                            <span className="hide-on-large-devices">Spar op til</span>
                        </h3>
                        <table>
                            <tbody>
                            <tr>
                                <td>Oprettelse</td>
                                <td>{formatAmountWithCurrency(oprettelse)}</td>
                            </tr>
                            <tr>
                                <td>Tilslutning</td>
                                <td>{formatAmountWithCurrency(tilslutning)}</td>
                            </tr>
                            <tr>
                                <td>Kampagnerabat i {tid}&nbsp;mdr.</td>
                                <td>{formatAmountWithCurrency(rabat)}</td>
                            </tr>
                            </tbody>
                            <tfoot>
                            <tr>
                                <td><strong>I alt<span className="hide-on-small-devices"> op til</span></strong></td>
                                <td><strong>{formatAmountWithCurrency(total)}</strong></td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div className="stamp-container">
                        <Icon component={IconArrow}/>
                        <div className="stamp">
                            <p>
                                Spar op til<br/>
                                <strong>{total}<span className="comma-dash">,-</span></strong>
                            </p>
                        </div>
                    </div>
                    <div className="cta-container">
                        <p>
                            Bestil <strong><button className={"link"} onClick={() => DispatchHighLightAddressSearchEvent(true)}>her</button></strong><br/>
                            Eller ring på<br/>
                            <strong><a href={`tel:+45` + phone}>
                                <PhoneNumberSpanComponent phoneNo={phone}/>
                            </a></strong>
                        </p>
                    </div>
                </div>
                <p className="conditions">
                    Tilbuddet er inkl. gratis tilslutning, oprettelse, forsendelse og wifi-router.
                    Pris efter {tid} mdr. {_default} kr./md.
                    Min. pris i 6 mdr. {formatAmountWithCurrency(min_6)} Tilbuddet er kun fiber via {network} og gælder ikke alle adresser.
                    Forudsætter at du ikke har været kunde de seneste 6 mdr.
                    Gælder udvalgte adresser t.o.m. {end}.
                </p>
            </div>

        </>
    )
}
